// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34kt4","footer":"styles_footer__14TE-","passCodeTooltip":"styles_passCodeTooltip__2KEUI"};